const getMinuteTimestamp = () => {
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(now.getUTCDate()).padStart(2, '0');
  const hour = String(now.getUTCHours()).padStart(2, '0');
  const minute = String(now.getUTCMinutes()).padStart(2, '0');

  // Combine year, month, day, hour, and minute to form a unique timestamp for the minute
  return `${year}${month}${day}${hour}${minute}`;
};

export default getMinuteTimestamp;
